<!--
* www.cloudscope.cn
* Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 11:57:16
 * @Description: 删除组件
-->
<template>
    <!-- 消息提醒 Dialog: Begin -->
    <el-dialog
        title="消息提醒"
        :visible.sync="dialogVisible"
        custom-class="mod-dialog"
        append-to-body
        @close="close"
        width="500px"
    >
        <span>请您确定是否删除此项数据，数据删除后不可恢复？</span>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="width:72px" type="info" @click="close">取消</el-button>
            <el-button size="mini" style="width:72px" type="primary">确定</el-button>
        </span>
    </el-dialog>
    <!-- 消息提醒 Dialog: Begin -->
</template>

<script>
export default {
    components: {},
    data () {
        return {
            dialogVisible: false
        };
    },
    mounted () {},
    methods: {
        /**
         * @author:liuchang
         * @description:关闭弹窗
         * @param {}
         */
        close () {
            this.dialogVisible = false;
            this.$emit('DeleteShow');
        },
        /**
         * @author:liuchang
         * @description:打开弹窗
         * @param {}
         */
        open () {
            this.dialogVisible = true;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ./src/components/Delete.vue